import { render, staticRenderFns } from "./AbstractResultCard.vue?vue&type=template&id=1fe7a5e8&scoped=true"
import script from "./AbstractResultCard.vue?vue&type=script&lang=js"
export * from "./AbstractResultCard.vue?vue&type=script&lang=js"
import style0 from "./AbstractResultCard.vue?vue&type=style&index=0&id=1fe7a5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe7a5e8",
  null
  
)

export default component.exports